module.exports = __webpack_public_path__ + "static/img/banner_3.6bc38d1f.jpg";